// React Hook for Roles
// Fetch and manage roles from RBAC system

import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { filterAssignableRoles } from '../constants/rbacConstants';

/**
 * Hook to fetch all roles from the roles collection
 */
export function useRoles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoading(true);
        setError(null);

        const rolesCollection = collection(db, 'roles');
        const q = query(rolesCollection, orderBy('name', 'asc'));
        const snapshot = await getDocs(q);

        const rolesData = filterAssignableRoles(snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })));

        setRoles(rolesData);
      } catch (err) {
        console.error('Error fetching roles:', err);
        setError(err.message);
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  return { roles, loading, error };
}

/**
 * Hook to fetch active roles only
 */
export function useActiveRoles() {
  const { roles, loading, error } = useRoles();
  
  const activeRoles = roles.filter(role => role.isActive !== false);
  
  return { roles: activeRoles, loading, error };
}


